<template>
 <div class="meeting">
   <el-dialog
     class="home-background"
     :visible.sync="dialogVisible"
     width="45%"

     :before-close="handleClose">
     <img :src="currUrl"/>
   </el-dialog>

   <img class="meeting-img" src="/static/img/meeting/meeting.png" alt="">

   <div class="meeting-img-div">
   <el-carousel
     indicator-position="none"
     class="meeting-img-container" :interval="4000" type="card" height="550px"  >
     <el-carousel-item class="meeting-img-container-item" v-for="item in imgList" :key="item.url">

       <img @click="model(item.url)" class="meeting-img-min" :src=item.url alt="" :key="item.url">
     </el-carousel-item>
   </el-carousel>
</div>

   <div class="meeting-video">
     <h1 class="meeting-video-h1">COC2021 开幕视频</h1>
     <video
       class="meeting-video-container"
       src="https://c-mbs.oss-cn-beijing.aliyuncs.com/Video/COC2021.mp4"
            controls="controls">
       您的浏览器暂时不支持video标签

     </video>
   </div>


    <div class="news">
    <div class="news-content">
      <h2 class="news-content-h2">首届中国肥胖大会举行，中国肥胖防治迎来多学科融合规范新时代</h2>

      <span class="news-content-span">
                聚焦肥胖，协作启航。7月30-31日，由国家消化系统疾病临床医学研究中心（北京）、北京医师协会减重与代谢专科医师分会联合主办的首届中国肥胖大会在北京国家会议中心举行，来自肥胖相关心血管疾病、内分泌代谢疾病、减重与代谢外科、代谢基础及转化研究、营养学等领域头部专家齐聚一堂，共商共议中国肥胖防治的最优策略与长期获益。大会倡导多领域全行业交叉融合，20余场学术会议同步开展，非公医疗机构与公立医疗机构深度探讨，药械产学研一体化集中展示。
      </span>

      <span class="news-content-span">
        会议现场首次发布我国建立时间最早、覆盖范围最广、登记数量最大的减重与代谢手术大数据《大中华减重与代谢手术数据库》，填补了中国减重与代谢外科肥胖治疗长期结局的数据空白。《中国超重/肥胖医学营养减重指南2021解析》等4部指南共识同场发布，中国肥胖防治迎来多学科融合规范新时代。
      </span>

      <div class="news-img">
           <img src="/static/img/news/641.webp" alt="">
         <span>首届中国肥胖大会正式启幕</span>
      </div>

      <h2>中国肥胖人数15年增3倍，肥胖本身就是一种病，得治！</h2>
      <span class="news-content-span">
        2018年中国18至69岁成年人中的肥胖人数约为8500万，其中男性约4800万，女性约3700万。大会开幕式上，人民卫生出版社李新华教授分享了其在《柳叶刀》在线发表的国人肥胖趋势研究数据，强调中国的肥胖人数在15年间连续增长了约3倍，一半成人超重或肥胖，呼吁更加积极、有针对性的防治应对。
      </span>
      <div class="news-img">
        <img src="/static/img/news/642.webp" alt="">
        <span>大会名誉主席、国家食品安全风险评估中心陈君石院士致辞</span>
      </div>

      <span class="news-content-span">
        “肥胖其实是一种营养不良，2014在罗马召开的第二届世界营养大会就已经明确了这一点。与此同时，肥胖还是多种主要慢性病比如心血管疾病、糖尿病的独立危险因素，与癌症比如食管癌的发生发展也紧密相关。”大会名誉主席、国家食品安全风险评估中心陈君石院士强调，肥胖已经成为一场“公共健康危机”，需要临床医学、公共卫生、药物研发等医药卫生全行业及政府机构与全社会的共同关注、联合攻关。
      </span>

      <div class="news-img">
        <img src="/static/img/news/643.webp" alt="">
        <span>大会名誉主席、中国高血压联盟终身名誉主席刘力生教授致辞</span>
      </div>

      <span class="news-content-span">
        事实上，早在2015年，中国就已经成为“世界首胖”，肥胖人数及肥胖儿童人数均居世界第一，但是社会各界包括医药卫生行业却对肥胖一直存在认知误区。中国肥胖大会主席、我国减重与代谢外科领军专家、首都医科大学附属北京友谊医院副院长张忠涛教授介绍，早在1948年,世界卫生组织就将“肥胖症”列为一种疾病。与此同时，肥胖尤其重度肥胖与高血压、高血脂、高血糖、高尿酸这“四高”关系暧昧，容易引发一系列重大慢病，治疗起来非常复杂，亟需更多重视与有效防治。
      </span>

      <span class="news-content-span">
        “从医药卫生经济学的角度，控制好肥胖也是为国家、为大众省钱。肥胖人群的医药费用要比普通人高得多。”张忠涛教授呼吁相关部门能够更多关注肥胖防治问题、督导肥胖防治进程。经济合作与发展组织(OECD)曾经发布的一份报告显示，肥胖者的处方量是体重正常者的2.4倍，他们住院时间更长，并且需要更昂贵、更复杂的治疗。糖尿病70%的治疗费用、心血管疾病23%的治疗费用和癌症9%的治疗费用都是由超重造成。
      </span>

      <div class="news-img">
        <img src="/static/img/news/644.webp" alt="">
        <span>大会主席、我国减重与代谢外科领军专家、首都医科大学附属北京友谊医院副院长张忠涛教授致辞</span>
      </div>

      <h2>4部指南共识同期发布，中国肥胖防治迎来融合规范发展新局面</h2>

      <span class="news-content-span">
        大会现场，中国首个超重肥胖医学营养减重指南《中国超重/肥胖医学营养治疗指南（2021）》，《肥胖患者多学科综合治疗指南》，《糖代谢与心血管疾病共识》，《减重与代谢外科手术病人影像学检查临床适用性评价指南（2021年版）》共4部肥胖治疗指南共识同期发布，相关牵头专家分别进行权威解读，共同推动中国肥胖防治融合规范发展新进程。
      </span>

      <span class="news-content-span">
        “科学减重，营养先行。营养是体重管理中生活方式干预的核心部分。我们经过五年的实践摸索积累了大量临床经验和证据，邀请全国百位营养与代谢领域权威专家，共同制定发布中国首个超重肥胖医学营养减重指南，阐释从如何生活减重，如何用精准营养的手段减重，到如何用生活手段让减下来的重不反弹，旨在为中国临床营养医生提供高效、循证、实用的医学营养减重方案”，大会执行主席、《中国超重/肥胖医学营养治疗指南（2021）》的牵头制定专家、北京协和医院营养科陈伟教授介绍。
      </span>

      <span class="news-content-span">
        “更融合、更规范，是行业对中国肥胖防治领域的共同期待。”大会执行主席、首都医科大学附属北京友谊医院减重与代谢外科主任张鹏教授介绍，肥胖治疗最终一定是走向多学科综合治疗，只有肥胖相关心血管、内分泌、代谢疾病、减重与代谢外科、营养等学科交叉融合起来，才能为“胖友”们提供肥胖不同阶段、不同合并症表现的最佳治疗方案。本次《肥胖患者多学科综合治疗指南》、《糖代谢与心血管疾病共识》等的共同发布，昭示中国医学各界正在携起手来，合力筑建肥胖防治“护城河”。
      </span>

      <span class="news-content-span">
        “我对肥胖的直观认知来自于我的患者。门诊里，来找我的很多难治性高血压患者都是肥胖人群。”大会执行主席、中国医学科学院阜外医院心血管内科张宇清教授介绍，减重可以有效减少心血管相关疾病的发生风险与健康危害，但是看起来很简单的事，目前却没有一个非常集中的解决路径。我们目前的临床科室设置都是专注于各个细分专业，没有一个能够综合管理肥胖患者体重、全周期全方位管理他们健康的地方。“中国肥胖防治多学科交叉融合的下一步，在临床层面的体现就是多学科一站式体重管理中心的建设与推广。”张忠涛教授表示，体重管理不是哪一个科室的事，而应该涵盖内分泌、心血管、代谢专业、减重外科、营养学等相关专业，为患者提供一体化、全流程、根本性的解决方案。
      </span>

      <div class="news-img">
        <img src="/static/img/news/645.webp" alt="">
        <span>首届中国肥胖大会媒体沟通会同期举行</span>
      </div>

      <h2>首个减重手术大数据报告出炉，填补中国减重与代谢外科长期结局数据空白</h2>

      <span class="news-content-span">
        “女性减重手术患者是男性的近4倍”“29%的患者术前存在2型糖尿病病史；34%的患者术前存在高血压病史；41%的患者术前存在呼吸睡眠暂停综合征病史；42%的患者术前存在血脂异常；93%的患者术前腹部超声提示脂肪肝等。”“减重与代谢手术后1年，BMI同比下降31.5%。”……
      </span>

      <span class="news-content-span">
        大会进行到高潮，来自21个地区、75家中心的近9000例减重与代谢手术临床大数据报告发布。这份来自《大中华减重与代谢手术数据库》的报告，历时3年筹备谋划、成果初显，是我国建立时间最早、覆盖范围最广、登记数量最大的减重与代谢手术大数据。
      </span>

      <div class="news-img">
        <img src="/static/img/news/646.webp" alt="">
        <span>我国首个减重手术大数据报告发布</span>
      </div>

      <h2>首个减重手术大数据报告出炉，填补中国减重与代谢外科长期结局数据空白</h2>

      <span class="news-content-span">
        张忠涛教授介绍，临床实践中，减重外科手术是唯一能够实现短期和长期持续减重，改善并发症，降低死亡率，提高生活质量的干预措施。“美国、欧洲长达15年的减重手术随访数据显示，术后超重体重可平均下降80%，且有超过50%的糖尿病患者术后血糖回归正常。但是相比国外，国内减重手术的数据搜集与研究比较匮乏，为中国减重手术的标准化规范、均质化推广带来障碍。与此同时，如果中国没有自己的减重手术数据，那么什么样的患者应该做手术、应该做哪种手术、手术需要怎么做，都将受制于欧美数据，而不能给中国患者提供贴合国人特性的手术方案。我们需要中国人自己的减重手术数据成果，未来也根据这些数据制定更加符合中国肥胖人群的指南共识。”
      </span>

      <div class="news-img">
        <img src="/static/img/news/647.webp" alt="">
      </div>


      <span class="news-content-span">
        开幕式现场，大会名誉主席、中华医学会会长、北京协和医院名誉院长赵玉沛院士向大会发来贺信，大会名誉主席陈君石院士、刘力生教授，大会主席张忠涛教授分别上台致辞。大会共同主席、北京大学人民医院内分泌科主任纪立农教授发表《肥胖领域研究进展及药物研发现状》主题演讲；大会共同主席、陆军军医大学大坪医院高血压内分泌科主任祝之明教授发表《代谢手术治疗肥胖相关性高血压的机制与获益》主题演讲；大会特邀嘉宾、兰州大学第一医院院长助理祁小龙教授发表《推进肝硬化门脉高压创新技术研发及防治体系构建》主题演讲。
      </span>

      <span class="news-content-span">
        “2016年是‘中国肥胖元年’，中国肥胖人群数首次超过世界其他国家，肥胖开始成为中国公共健康危机。2021年，秉持引领中国肥胖防治多学科多领域交叉融合、共同应对的真挚愿景，中国肥胖大会破茧而出、应运而生。”张忠涛教授表示，未来，中国肥胖大会将继续汇聚行业力量，“共商学术、共建平台、共促发展”，为推动中国肥胖防治的综合发展进程贡献力量。
      </span>

      <div>
        本文转自人民日报健康客户端
      </div>
    </div>
    </div>
   <footer class="footer">
     <div class="wrap">
       <a href="#" class="f-logo wow fadeInLeft"><img src="/static/img/f-logo.png"/></a>
       <!--			<p class="wow fadeInRight">地址：北京丰台区汉威广场二区1号楼6M层</p>-->
       <p class="wow fadeInRight">Copyright © 2017-2020 大中华减重与代谢外科数据平台京ICP备17044059号 </p>
       <p>平台支持：<a target="_blank" href="http://www.edocdata.com/">北京易得医数科技有限责任公司</a></p></div>
   </footer>
 </div>
</template>

<script>

import VueCountUp from 'vue-countupjs'
import {WOW} from 'wowjs'

export default {
  components: {VueCountUp},
  name: "meeting",
  data(){
    return{
      imgList:[
        {
          url: require('../../static/img/meeting/COC2021-1.jpg'),
        }, {
          url: require('../../static/img/meeting/COC2021-2.jpg'),
        }, {
          url: require('../../static/img/meeting/COC2021-3.jpg'),
        }, {
          url: require('../../static/img/meeting/COC2021-4.jpg'),
        },
        {
          url: require('../../static/img/meeting/COC2021-5.jpg'),
        }, {
          url: require('../../static/img/meeting/COC2021-6.jpg'),
        }, {
          url: require('../../static/img/meeting/COC2021-7.jpg'),
        }, {
          url: require('../../static/img/meeting/COC2021-8.jpg'),
        }, {
          url: require('../../static/img/meeting/COC2021-9.jpg'),
        }, {
          url: require('../../static/img/meeting/COC2021-10.jpg'),
        }, {
          url: require('../../static/img/meeting/COC2021-11.jpg'),
        }, {
          url: require('../../static/img/meeting/COC2021-12.jpg'),
        }, {
          url: require('../../static/img/meeting/COC2021-13.jpg'),
        },{
          url: require('../../static/img/meeting/COC2021-14.jpg'),
        },{
          url: require('../../static/img/meeting/COC2021-15.jpg'),
        },{
          url: require('../../static/img/meeting/COC2021-16.jpg'),
        },{
          url: require('../../static/img/meeting/COC2021-17.jpg'),
        },{
          url: require('../../static/img/meeting/COC2021-18.jpg'),
        },{
          url: require('../../static/img/meeting/COC2021-19.jpg'),
        },{
          url: require('../../static/img/meeting/COC2021-20.jpg'),
        },{
          url: require('../../static/img/meeting/COC2021-21.jpg'),
        },{
          url: require('../../static/img/meeting/COC2021-22.jpg'),
        },{
          url: require('../../static/img/meeting/COC2021-23.jpg'),
        },
        {
          url: require('../../static/img/meeting/COC2021-24.jpg'),
        },{
          url: require('../../static/img/meeting/COC2021-25.jpg'),
        },{
          url: require('../../static/img/meeting/COC2021-26.jpg'),
        },{
          url: require('../../static/img/meeting/COC2021-27.jpg'),
        },{
          url: require('../../static/img/meeting/COC2021-28.jpg'),
        },{
          url: require('../../static/img/meeting/COC2021-29.jpg'),
        },{
          url: require('../../static/img/meeting/COC2021-30.jpg'),
        },{
          url: require('../../static/img/meeting/COC2021-31.jpg'),
        },{
          url: require('../../static/img/meeting/COC2021-32.jpg'),
        },{
          url: require('../../static/img/meeting/COC2021-33.jpg'),
        },
      ],
      dialogVisible:false,
      currUrl:''
    }
  },
  methods:{
    model(url){
      // console.log(url);
      this.currUrl= url
      this.dialogVisible = true
    },
    handleClose(){
      this.currUrl= ''
      this.dialogVisible = false

    }
  },
  mounted() {

    this.$nextTick(() => {
      var wow = new WOW({
        live: false
      })
      wow.init()
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/meeting.vue